import type { AdvertCountResult } from '@/generated-api'
import { useJobmatchStore } from '@/stores'

export const capitalizeFirstLetter = (string: string) => {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const replaceNewLineWithLineBreak = (text: string | undefined) => {
  if (text === undefined || text === '') {
    return ''
  }

  return text.replace(/\n/g, '<br />')
}

export const formatUrlString = (url: string | undefined): string => {
  if (url === undefined || url === '') {
    return ''
  }

  // A regular expression to remove https://, http://, and www
  const domain = url.replace(/https?:\/\/|www\./g, '')
  const parts = domain.split('/')
  const [subdomain, domainName] = parts[0].split('.')

  return `${subdomain}.${domainName}`
}

export const convertJobMatchCountText = async (
  countText: string | undefined,
  jobmatchCount: AdvertCountResult | undefined
): Promise<string> => {
  if (countText === undefined || jobmatchCount === undefined) {
    return ''
  }

  // Create record with same names as AdvertCountResult, to easely access correct day value
  const countMap: Record<string, number> = {
    countLastDay: 1,
    countLastThreeDays: 3,
    countLast7Days: 7,
    countLast14Days: 14
  }

  // This is the order we want to go through jobMatchCount object from response
  const countProperties = [
    'countLastDay',
    'countLastThreeDays',
    'countLast7Days',
    'countLast14Days',
    'countTotal'
  ]

  let jobmatchCountValue = 0
  let jobmatchCountDays = 0

  countProperties.find((count: string) => {
    const value = jobmatchCount[count as keyof AdvertCountResult]

    // we don't need to show count text if count is countTotal
    if (value !== undefined && value > 5 && count !== 'countTotal') {
      jobmatchCountValue = value
      jobmatchCountDays = countMap[count]

      const jobmatchStore = useJobmatchStore()
      jobmatchStore.setBlockItemJobsFound(value)

      return true
    }

    return false
  })

  if (jobmatchCountValue === 0 || jobmatchCountDays === 0) {
    return ''
  }

  return replaceWordsWithValues(countText, {
    count: `<strong>${jobmatchCountValue}</strong>`,
    days: `<strong>${jobmatchCountDays}</strong>`
  })
}

interface NamedValues {
  [key: string]: string
}

export const replaceWordsWithValues = (
  text: string | undefined,
  values: NamedValues | undefined
): string => {
  if (text === undefined || text === '') {
    return ''
  }
  const placeholderPattern = /\{\{.*?\}\}/
  const containsPattern = placeholderPattern.test(text)

  if (containsPattern === true && values !== undefined) {
    // Replace each {{name}} with the corresponding value from the values object
    text = text.replace(/\{\{(.*?)\}\}/g, (match, p1) => {
      return values[p1] || match // If the name is not found in values, keep the original placeholder
    })
  }

  return text
}
